import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetBlogDetailsQuery } from '../../Api/blogApi';
import Navigation from '../../Components/Navigation/Navigation';
import logo from '../../assets/images/logo.svg';
import blogDummy from '../../assets/images/blogdummy.jpeg';
import './Blogs.scss';
import Footer from '../../Components/Footer/Footer';
import ContactUs from '../ContactUs/ContactUs';
import Contect from '../Home/Components/Contect';
import Lottie from 'lottie-react';
import loaderAnimation from '../../Tick Animation - KoolMind.json';

const COMPANY_NAME = 'KoolMind Technolab LLP';

const BlogDetails = () => {
  const { id } = useParams();
  const { data: blog, isLoading } = useGetBlogDetailsQuery(id);

  if (isLoading) return (
    <div className="blog-loader-wrapper">
      <Lottie animationData={loaderAnimation} loop={true} style={{ width: 120, height: 120, margin: '100px auto' }} />
    </div>
  );
  if (!blog) return <div>Blog not found</div>;

  return (
    <>
      <Navigation offer={true} />
      <div className="container blog-details-container">
        <h1 className="blog-details-title">{blog.title?.rendered}</h1>
        <div className="blog-details-header">
          <div className="blog-details-meta">
            <div className="blog-details-info">
              <div>
                <div className="blog-details-company">{COMPANY_NAME}</div>
                <span>👁 {blog.view_count || 100} Views</span>
                <span>📅 {blog.date ? new Date(blog.date).toLocaleDateString() : 'No date available'}</span>
              </div>
              <button className="blog-details-share">+ Share With Others</button>
            </div>
          </div>
        </div>
        <div className="blog-details-image-wrapper">
          <img
            className="blog-details-image"
            src={blog?.featured_image || blogDummy}
            alt={blog.title?.rendered || 'Blog image'}
          />
        </div>
        <div className="blog-details-content" dangerouslySetInnerHTML={{ __html: blog.content?.rendered }} />
      </div>
      <Contect />
      <Footer/>
    </>
  );
};

export default BlogDetails; 